<template>
  <div>
    <FormulateForm
      name="signup"
      v-model="formValues"
      @submit="register"
      class="mb-6"
    >
      <h1 class="font-bold text-3xl mb-8">
        Signup
      </h1>

      <FormulateInput
        name="email"
        type="email"
        label="Email address"
        placeholder="Email address"
        validation="bail|required|email"
      />
      <FormulateInput
        name="password1"
        type="password"
        label="Password"
        placeholder="Your password"
        validation="bail|required|min:8,length"
        validation-name="Password"
      />
      <FormulateInput
        name="password2"
        type="password"
        label="Confirm your password"
        placeholder="Confirm password"
        validation="bail|required|confirm:password1"
        validation-name="Confirmation"
      />
      <FormulateErrors />
      <base-button type="submit" :loading="sending">
        Sign up
      </base-button>
    </FormulateForm>

    <span class="text-sm mr-2">Already have an account?</span>
    <router-link
      to="/login"
      class="inline-block text-sm text-black border-b-2 border-transparent hover:border-blue-400"
    >
      Log in.
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formValues: {},
      sending: false,
    };
  },
  methods: {
    async register(data) {
      try {
        this.sending = true;
        await this.$api.post('rest-auth/registration/', data);
      } catch (error) {
        this.$formulate.handle(error, 'signup');
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
